function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.28711 14.7031C1.8584 14.7031 2.24512 14.3076 2.24512 13.7363C2.24512 13.4023 2.21875 13.0508 2.21875 12.5586C2.21875 9.64062 3.24707 8.4541 6.13867 8.4541H11.8076L13.9082 8.33105L11.333 10.6777L9.36426 12.6641C9.18848 12.8398 9.07422 13.0859 9.07422 13.3584C9.07422 13.8945 9.47852 14.2988 10.041 14.2988C10.2871 14.2988 10.5244 14.2021 10.7354 13.9912L16.5273 8.20801C16.7383 8.00586 16.8525 7.74219 16.8525 7.47852C16.8525 7.20605 16.7383 6.94238 16.5273 6.74023L10.7529 0.974609C10.5244 0.754883 10.2871 0.649414 10.041 0.649414C9.47852 0.649414 9.07422 1.05371 9.07422 1.58984C9.07422 1.8623 9.17969 2.1084 9.36426 2.28418L11.333 4.2793L13.8994 6.61719L11.8076 6.49414H6.01562C1.95508 6.49414 0.241211 8.375 0.241211 12.4971C0.241211 13.0156 0.258789 13.4727 0.329102 13.8242C0.408203 14.2549 0.680664 14.7031 1.28711 14.7031Z",
  fill: "#878793"
});

function SvgIconRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedo);
export default __webpack_public_path__ + "static/media/icon-redo.4c7e6eb6.svg";
export { ForwardRef as ReactComponent };